import { Component } from 'react'
import { graphql, compose } from 'react-apollo'

import { $ } from 'utils'
import { Loader } from 'components'
import { MATCH_PERSON } from 'queries/matching'
import { withConsumer } from 'store'

import Results from './Results'

class MatchingPerson extends Component {

  render() {
    const { closeBottomPanel, type, matchType, data: { loading, match, error, person } } = this.props
    if (loading) return $(Loader)

    return (
      $(Results, { closeBottomPanel, type, matchType, results: match, source: person, loading, error })
    )
  }
}

export default compose(
  graphql(MATCH_PERSON, {
    options: props => ({
      variables: {
        fetchPolicy: 'cache-and-network',
        personId: props.personId,
        limit: +props.limit,
        listId: props.listId,
        descriptorIds: props.descriptorIds,
      }
    })
  })
)(withConsumer(MatchingPerson, '/persons'))




// WEBPACK FOOTER //
// ./src/components/panels/MatchingResults/MatchingPerson.js